import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { get, merge } from 'lodash';
import { reduxForm, formValueSelector } from 'redux-form';
import { push } from 'connected-react-router';
import { fetchEntity, createEntityForm, addNewWorkOrderToCreateForm, addNewCustomChannelToCreateForm, cloneExistingWorkOrderToCreateForm, resetWorkOrderToMatchBrandCreate, clearSearchForOpportunities, switchAllWorkOrderPlatformsCreate } from 'services/entities/duck';
import EditEntityForm from 'components/organisms/entity/edit/Form';
import { fetchList as fetchBrandList } from 'services/brands/duck';
import { CHANNEL_DS_CONFIG } from 'constants/channels';
import { ENTITY_PLATFORMS } from 'constants/entityPlatforms';
import { getDefaultChannelDataSources, getDefaultEnabledChannels, supportedChannelNamesList } from 'helpers/channels';

const formName = 'createEntity';

class CreateEntityContainer extends Component {
    constructor() {
        super();

        this.setAllChannelDataSources = this.setAllChannelDataSources.bind(this);
        this.updateEntityChannelConfigWithBrand = this.updateEntityChannelConfigWithBrand.bind(this);
        this.updateEntityShowAdvancedOptionsWithBrand = this.updateEntityShowAdvancedOptionsWithBrand.bind(this);
    }

    componentDidMount() {
        this.props.fetchBrandList();
        this.props.clearSearchForOpportunities();
        if (this.props.fetchEntity && this.props.seededTemplateId) {
            this.props.fetchEntity({ entityId: this.props.seededTemplateId });
        }
    }

    setAllChannelDataSources(value) {
        CHANNEL_DS_CONFIG[this.props.initialValues.entityPlatform].forEach((config) => {
            this.props.change(`meta.channelDataSources.${config.channel}`, value);
        });
    }

    updateEntityChannelConfigWithBrand(brandMeta) {
        if (!this.props.selectedOverrideBrandEnabledChannels) {
            supportedChannelNamesList.forEach((channel) => {
                const key = `channelConfig.${channel}.enabled`;
                const value = get(brandMeta, key, false);
                this.props.change(`meta.${key}`, value);
            });
        }
    }

    updateEntityShowAdvancedOptionsWithBrand(brandMeta) {
        if (!this.props.selectOverrideBrandAdvancedOptions) {
            const key = 'showTotalActivities';
            const value = get(brandMeta, key, false);
            this.props.change(`meta.${key}`, value);
        }
    }

    selectOverrideBrandAdvancedOptions(brandMeta) {
        // Only update the meta of the entity if there is an entity and a the flag is set
        if (!this.props.selectOverrideBrandAdvancedOptions && this.getEntityId()) {
            for (const key of ['showTotalActivities', 'showTargetingTactics', 'enableObjectiveSwitching', 'showeCPAonSummaryDashboard', 'enforceSummaryOnlyDashboardView', 'showSemCpconv', 'showSocialCpconv', 'showFacebookDemographicData', 'showSocialExpandModules', 'showTtdSitesSummary']) {
                const value = get(brandMeta, key, false);
                this.props.change(`meta.${key}`, value);
            }
        }
    }

    selectOverrideBrandDisplayConfiguration(brandMeta) {
        // Only update the meta of the entity if there is an entity and a the flag is set
        if (!this.props.selectOverrideBrandDisplayConfiguration && this.getEntityId()) {
            const value = get(brandMeta, 'programmaticObjective.labelCode', '');
            this.props.change('meta.programmaticObjective.labelCode', value);
        }
    }

    render() {
        return (
            <EditEntityForm
                formName={formName}
                handleSubmit={this.props.handleSubmit.bind(null, createEntityForm)}
                dispatch={this.props.dispatch}
                handleNewWorkOrder={this.props.addNewWorkOrderToCreateForm}
                handleNewCustomChannel={this.props.addNewCustomChannelToCreateForm}
                handleCloneExistingWorkOrder={this.props.cloneExistingWorkOrderToCreateForm}
                handleOverrideRemoval={this.props.resetWorkOrderToMatchBrandCreate}
                switchWorkOrderPlatforms={this.props.switchAllWorkOrderPlatformsCreate}
                currentUser={this.props.currentUser}
                handleCancel={() => this.props.push('/admin/entities')}
                brands={this.props.brands}
                entityPlatform={this.props.initialValues.entityPlatform}
                updateEntityChannelConfigWithBrand={this.updateEntityChannelConfigWithBrand}
                setAllChannelDataSources={this.setAllChannelDataSources}
                updateEntityShowAdvancedOptionsWithBrand={this.updateEntityShowAdvancedOptionsWithBrand}
                selectedBrandId={this.props.selectedBrandId}
                selectedLabelCode={this.props.selectedLabelCode}
                selectedOverrideBrandEnabledChannels={this.props.selectedOverrideBrandEnabledChannels}
                selectOverrideBrandAdvancedOptions={this.props.selectOverrideBrandAdvancedOptions}
                selectOverrideBrandDisplayConfiguration={this.props.selectOverrideBrandDisplayConfiguration}
                seededSalesforceId={this.props.seededSalesforceId}
                metaLoaded={true} >
                {this.props.children}
            </EditEntityForm>
        );
    }
}

const formSelector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const entityPlatform = get(state.router.parsedUrl.query, 'entity-platform', ENTITY_PLATFORMS.default);
    const seededTemplateEntity = get(state, 'entities.entity');
    const seededTemplateId = get(state, 'router.parsedUrl.query.templateId');
    const initialValues = merge({
        version: 2,
        entityPlatform: 'ccms', // this is deprecated
        isDemo: false,
        meta: {
            spendMarkup: { type: 'percentage', value: 0 },
            channelConfig: getDefaultEnabledChannels(),
            channelDataSources: getDefaultChannelDataSources(entityPlatform),
            overrideBrand: {
                enabledChannels: false,
                showTotalActivities: false,
                showTargetingTactics: false,
                enableObjectiveSwitching: false,
                showeCPAonSummaryDashboard: false,
                enforceSummaryOnlyDashboardView: false,
                showSemCpconv: false,
                showSocialCpconv: false,
                showSocialExpandModules: false,
                showFacebookDemographicData: false,
                showTtdSitesSummary: false
            }
        }
    }, seededTemplateId ? seededTemplateEntity : {});

    if (seededTemplateId && seededTemplateEntity) {
        initialValues.Users = [];
        delete initialValues.id;
        delete initialValues.createdAt;
        delete initialValues.updatedAt;
        initialValues.name = `Copy of ${seededTemplateEntity.name}`;
    }

    const seededSalesforceId = get(state, 'router.parsedUrl.query.salesforceId');
    return {
        currentUser: state.users.currentUser,
        brands: state.brands.list,
        seededSalesforceId,
        seededTemplateId,
        initialValues,
        selectedLabelCode: formSelector(state, 'meta.programmaticObjective.labelCode'),
        selectedBrandId: formSelector(state, 'brandId'),
        selectedOverrideBrandEnabledChannels: formSelector(state, 'meta.overrideBrand.enabledChannels'),
        selectOverrideBrandAdvancedOptions: formSelector(state, 'meta.overrideBrand.advancedOptions'),
        selectOverrideBrandDisplayConfiguration: formSelector(state, 'meta.overrideBrand.objectiveLabel')
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, stateProps, dispatchProps, ownProps);

export default compose(
    connect(mapStateToProps, {
        push,
        fetchBrandList,
        fetchEntity,
        clearSearchForOpportunities,
        addNewWorkOrderToCreateForm,
        addNewCustomChannelToCreateForm,
        cloneExistingWorkOrderToCreateForm,
        resetWorkOrderToMatchBrandCreate,
        switchAllWorkOrderPlatformsCreate
    }, mergeProps),
    reduxForm({
        form: formName,
        enableReinitialize: true,
    })
)(CreateEntityContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/CreateEntityV2Container.js